import { createContext, useCallback, useContext, useState } from 'react';

interface IDrawerOption {
  icon: string;
  path: string;
  label: string;
}

interface IDrawerContextData {// Define as propiedades compartilhadas no contexto
  isDrawerOpen: boolean;// Define o drawer aberto ou fechado
  toggleDrawerOpen: () => void;// Alternar entre aberto e fechado
  drawerOptions: IDrawerOption[];
  setDrawerOptions: (newDrawerOptions: IDrawerOption[]) => void
}

// O contexto recebe as propiedades compartilhadas
const DrawerContext = createContext({} as IDrawerContextData);

//Hook para usar o toggle drawer em qualquer parte da aplicação
export const useDrawerContext = () => {
  return useContext(DrawerContext);
}

interface IDrawerProviderProps{
  children: React.ReactNode 
}
export const DrawerProvider: React.FC<IDrawerProviderProps> = ({ children }) => {

//Use state para o drawer open, false como padrão para vir fechada
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//Use state para facilitar nas rotas
  const [drawerOptions, setDrawerOptions] = useState<IDrawerOption[]>([]); 

//Use callback se o aterior for true vira false e vice versa
  const toggleDrawerOpen = useCallback(() => {
    setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
  }, []);
//Use callback para poder acessar as opões do menu de qualquer lugar
  const handleSetDrawerOptions = useCallback((newDrawerOptions: IDrawerOption[]) => {
    setDrawerOptions(newDrawerOptions);
  }, []);

  return (
    // Da a propriedade para todos que estão abaixo e passa como filho 
    <DrawerContext.Provider value={{ isDrawerOpen, drawerOptions, toggleDrawerOpen, setDrawerOptions: handleSetDrawerOptions }}>
      {children}
    </DrawerContext.Provider>
  );
}